<template>
  <ExternalList
      headline="Projects"
      endpoint="/api/v2/project-leads?sort=project_ends_at"
      :endpoint-filters="{company_id: company.id, ends_after: now}"
      :headlines="headlines"
      :button-column-width="4"
      :can-show="() => true"
      :can-destroy="() => true"
      :show-checkboxes="false"
      :show-list-actions="false"
      :default-page-size="10"
      @show="projectLead => $router.push('/projects/' + projectLead.attributes.project_id)"
  >
    <template v-slot:default="{ row: projectLead }">
      <td class="table__ellipsis">
        <router-link :to="'/projects/' + projectLead.attributes.project_id">
          {{ projectLead.attributes.project_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        <Avatar
            v-if="projectLead.attributes.user_initials"
            :color="projectLead.attributes.user_color"
        >
          {{ projectLead.attributes.user_initials }}
        </Avatar>
      </td>

      <td class="table__ellipsis">
        <span v-if="projectLead.attributes.status === 'new'" class="label label-warning">
          New
        </span>

        <span v-if="projectLead.attributes.status === 'active'" class="label label-info">
          Active
        </span>

        <span v-if="projectLead.attributes.status === 'declined'" class="label label-danger">
          Declined
        </span>

        <span v-if="projectLead.attributes.status === 'sale'" class="label label-success">
          Sale
        </span>
      </td>

      <td class="table__ellipsis">
        {{ projectLead.attributes.portal_name }}
      </td>

      <td class="table__ellipsis">
        {{ projectLead.attributes.project_ends_at | date }}
      </td>
    </template>

    <template v-slot:modals="{ selected, update, load }">
      <CreateProjectLeadModal :company="company" @created="load"/>
    </template>

    <template v-slot:headline-right>
      <a href="#create-project-lead-modal" data-toggle="modal" class="btn btn-white btn-sm" style="margin-top: 4px;">
        <i class="fa fa-plus"></i> Create
      </a>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../../../../../components/Panels/Lists/External'
import moment from 'moment'
import CreateProjectLeadModal from "../Modals/CreateProjectLeadModal.vue";
import Avatar from "../../../../../../../components/Avatar.vue";

export default {
  components: {Avatar, CreateProjectLeadModal, ExternalList},

  props: {
    company: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 7, text: 'Name'},
        {width: 2, text: 'Assignee'},
        {width: 3, text: 'Status'},
        {width: 4, text: 'Portal'},
        {width: 4, text: 'Publish At'},
      ]
    },

    now() {
      return moment().format('YYYY-MM-DD')
    }
  }
}
</script>
